import React, { useEffect, useRef, useState, useCallback } from 'react';
import './pricelist.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getCity} from '../../services/userservice';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";


const HotelPriceList = () => {

  const [selectedCheckInDate, setSelectedCheckInDate] = useState(new Date()); 
  const [selectedCheckOutDate, setSelectedCheckOutDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
  }); 
  const [results, setResults] = useState([]);
  const [showDropdownFrom, setShowDropdownFrom] = useState(false);
  const [formDataCity, setFormDataCity] = useState(null);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const [searchCity, setSearchCity] = useState('');
  const [flightList, setFlightList] = useState([]);
  const [loading, setLoading] = useState(false);
  const gridApiRef = useRef(null);


  const debounce = (func, delay) => {
    let debounceTimer;
    return function (...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func(...args), delay);
    };
  };

  const handleCheckInDateChange = (date) => {
    setSelectedCheckInDate(date);
  };
  const handleCheckoutDateChange = (date) => {
    setSelectedCheckOutDate(date);
  };

  const handleInputCityChange = (e) => {
    setSearchCity(e.target.value);
    fetchCountryList(e.target.value);
  };
  const fetchCountryList = useCallback(
    debounce(async (term) => {
      if (term) {
        try {
          const data = await getCity(term);
          setFlightList(data);
        } catch (error) {
          console.error('Failed to fetch flight list', error);
        }
      }
    }, 500),
    []
  );
  function calculateFareRule(publishedPrice) {
    return publishedPrice + publishedPrice * 0.18;
  }
  
  function calculateDiscountedPrice(fareRule) {
    return fareRule - fareRule * 0.7;
  }
  
  function calculateTaxAndFee(fareRule) {
    return fareRule * 0.18;
  }
  
  function calculateProfit(discountedPrice, taxAndFee, offeredPrice) {
    return ((discountedPrice + taxAndFee) - offeredPrice);
  }
  
  // Function to call API on search click
  const handleSearch = async () => {
    setLoading(true)
    const requestData = {
      checkinDate: selectedCheckInDate.toISOString().split('T')[0],
      checkoutDate: selectedCheckOutDate.toISOString().split('T')[0],
      roomInfo: [
        {
          numberOfAdults: 1,
          numberOfChild: 0,
          childAge: []
        }
      ],
      searchCriteria: {
        city: formDataCity?.city,
        tboCityId: formDataCity?.tboCityId,
        tboCountryCode: formDataCity?.tboCountryCode,
        currency: "INR",
      },
      requestFrom:'admin'
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}hotel/hotel-checkin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'api-key': process.env.REACT_APP_SMT_V2_API_KEY
        },
        body: JSON.stringify(requestData),
      });
      if (response.ok) {
        const resultsData  = [];
        const data = await response.json();
        if (data?.hotels) {
          for (let index = 0; index < data.hotels.length; index++) {
            const hotel = data.hotels[index];
            if(hotel.name == 'Unnamed Hotel') {
              console.log(hotel.name);
              continue;
            }
            const publishedPrice = hotel.Price.PublishedPrice;
            const fareRule = calculateFareRule(publishedPrice);
            const discountedPrice = calculateDiscountedPrice(publishedPrice);
            const taxAndFee = calculateTaxAndFee(publishedPrice);
            const profit = calculateProfit(discountedPrice, taxAndFee, hotel.Price.OfferedPrice);

            resultsData.push({
              id: index + 1,
              name: hotel.name,
              Address: hotel.ad.adr || 'N/A',
              PublishedPrice: publishedPrice,
              OfferedPrice: hotel.Price.OfferedPrice,
              AgentCommission: hotel.Price.AgentCommission,
              FareRule: fareRule.toFixed(2),
              DiscountedPrice: discountedPrice.toFixed(2),
              TaxAndFee: taxAndFee.toFixed(2),
              Profit: profit.toFixed(2),
            });
          }
        }
        setResults(resultsData); // Update the results state with API response data
      } else {
        console.error('API request failed');
      }
    } catch (error) {
      console.error('Error during API call:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSelectFrom = (city) => {
    setFormDataCity(city);
    setShowDropdownFrom(false);
  }
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const exportCsv = () => {
    if (gridApiRef.current) {
      gridApiRef.current.exportDataAsCsv({ fileName: "HotelPriceList.csv" });
    }
  };

  const columnDefs = [
    { field: "id", headerName: "S. No.", sortable: true, filter: true,width: 70 },
    { field: "name", headerName: "Name", sortable: true, filter: true },
    { field: "Address", headerName: "Address", sortable: true, filter: true },
    { field: "PublishedPrice", headerName: "Published Price", sortable: true, search: true , width: 150},
    { field: "OfferedPrice", headerName: "Offered Price", sortable: true, filter: true , width: 150},
    { field: "AgentCommission", headerName: "Commission Earned", sortable: true, filter: true, width: 200  },
    { field: "FareRule", headerName: "Fare Rule (25%)", sortable: true, filter: true},
    { field: "DiscountedPrice", headerName: "Discounted Price", sortable: true, filter: true},
    { field: "TaxAndFee", headerName: "Tax & Fee", sortable: true, filter: true},
    { field: "Profit", headerName: "Profit", sortable: true, filter: true }
  ];
  return (
    <>
      <section className="content-wrapper">
        <div className="content-header">
          <div className="Banner_cntr">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body pb-0 flight_search text-center rounded-bottom-4">
                      <div className="row box">
                        <div className="col-lg-12">
                          <div className="row flight_change">
                            <div className="col-md-4 pe-md-1">
                              <div className="form-group">
                                <label className='from-title cursor-pointer'>Select City</label>
                                <button
                                  className='flight_from-search-btn'
                                  aria-label="Select City"
                                  onClick={() => setShowDropdownFrom(!showDropdownFrom)}
                                >
                                  <span className='flight-select-title'>{formDataCity?.cityName || "Select City"}</span>
                                  <span className='flight-select-subtitle text-truncate d-block'>{formDataCity?.countryName ? formDataCity?.countryName : "Country"}</span>
                                </button>
                                {showDropdownFrom && (
                                  <div ref={dropdownRef} className="search-list-container">
                                    <input
                                      placeholder="From ..."
                                      ref={inputRef}
                                      value={searchCity}
                                      onChange={handleInputCityChange}
                                      style={{ height: "60px" }}
                                    />
                                    {flightList?.data?.length > 0 }
                                    <ul className='search-list'>
                                      {flightList?.data?.map((city, index) => (
                                        <li key={index} onClick={() => handleSelectFrom(city)} className="flight-item">
                                          <span className="airportTitle">{`${city.cityName	}`}</span>
                                          <span className="airportSubTitle">{city.countryName	}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>
                                  <i className="fa fa-calendar" /> Check In
                                </label>
                                <DatePicker
                                  id="datepicker"
                                  selected={selectedCheckInDate}
                                  onChange={handleCheckInDateChange}
                                  dateFormat="dd/MM/yyyy"
                                  className="form-control"
                                />
                                <span>{selectedCheckInDate.toDateString()}</span>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>
                                  <i className="fa fa-calendar" /> Check Out
                                </label>
                                <DatePicker
                                  id="datepicker"
                                  selected={selectedCheckOutDate}
                                  onChange={handleCheckoutDateChange}
                                  dateFormat="dd/MM/yyyy"
                                  className="form-control"
                                />
                                <span>{selectedCheckOutDate.toDateString()}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        href="#"
                        className="btn btn-primary search_btn"
                        onClick={handleSearch}
                      >
                        Search
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="searchbar">
            <div className="container">
              <div className="card">
              <div className="card-header d-md-flex justify-content-between" style={{textAlign:'right'}}>
              {results.length > 0 && (
              <button className='export-csv-btn' onClick={exportCsv} disabled={results.length === 0}>
                Export CSV
              </button>)}
              </div>
                <div className="ag-theme-alpine" style={{ height: 800, width: "100%" }}>
                  {loading ? (
                    <div className="preloader">
                      <div className="loader"></div>
                      <div className="loader-text">Loading...</div>
                    </div>
                  ) : (
                    <AgGridReact
                      rowData={results} // Should be an array of objects
                      columnDefs={columnDefs}
                      pagination={true}
                      paginationPageSize={20}
                      enableCsvExport={true}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default HotelPriceList;